<template>
  <div class="screen-award-mission">
    <v-row>
      <v-col cols="12" md="3">
        <div class="tabs-navigator">
          <div class="user-point">
            <img src="../../../../assets/Avartar].png" alt="" srcset="" />
            <div class="point">
              <div class="username">username</div>
              <div class="point-vie">
                Viepoint: {{ starPoint }}
                <img src="../../../../assets/startPoint2.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="list-tabs">
            <div
              v-for="(tab, index) in listTabs"
              :key="index"
              class="tabs"
              :class="[tabIndex == index && `active`]"
              @click="activeTab(index)"
            >
              <img :src="tab.sub_image" alt="" />
              <span>{{ tab.tabsName }}</span>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="9">
        <component v-bind:is="listTabs[tabIndex].components"></component>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import iconTabMission from "../../../../assets/iconTabMission.png";
import Gift from "../../../../assets/Gift.png";
import MyGift from "../../../../assets/MyGift.png";
import ScreenMynAward from "./ScreenMyAward.vue";
import MyMission from "./MyMission.vue";
import ScreenRedem from "./ScreenRedeem.vue";
import { get } from "vuex-pathify";
export default {
  data() {
    return {
      tabIndex: localStorage.getItem("tabAwardIndex") || 0,
      listTabs: [
        {
          id: 1,
          tabsName: "Nhiệm vụ",
          sub_image: iconTabMission,
          components: MyMission,
        },
        {
          id: 2,
          tabsName: "Đổi Quà",
          sub_image: Gift,
          components: ScreenRedem,
        },
        {
          id: 3,
          tabsName: "Quà Của Tôi",
          sub_image: MyGift,
          components: ScreenMynAward,
        },
      ],
    };
  },
  async mounted() {
    document.getElementById("footer").style.display = "none";
  },
  computed: {
    starPoint: get("showcase/pointAward"),
  },
  methods: {
    activeTab(index) {
      localStorage.setItem("tabAwardIndex", index);
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
